/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
// TODO fix and remove eslint disables
import { db } from '../Firebase';
import { collection, limit, query, deleteDoc, orderBy, getDocs, doc, writeBatch } from 'firebase/firestore';
import { authed_user } from '../Users/observables';
import { shareReplay, map, switchMap, combineLatest, debounceTime, withLatestFrom } from 'rxjs';
import { collectionData } from 'rxfire/firestore';
import { cards } from '../Cards/observables';
import { uniq } from 'lodash';
import { ResultT } from '../shared/codecs/Result';
import { decodableInArray } from '../rxjs/Decode';
export const results_collection = authed_user.pipe(map(user => collection(db, 'organizations', user.organization, 'results')), shareReplay(1));
export const results = results_collection.pipe(switchMap(results_collection => {
    return collectionData(query(results_collection)).pipe(decodableInArray(ResultT), map((results) => results.filter(result => !result.deleted)), shareReplay(1));
}), shareReplay(1));
export const any_results = results.pipe(map((results) => results.length !== 0));
export const delete_last_result = results_collection.pipe(map(results_collection => {
    return async () => {
        const resultDocs = await getDocs(query(results_collection, orderBy('date', 'desc'), limit(1)));
        if (!resultDocs.docs[0]) {
            throw new Error('Attempting to delete the last result, but none were found');
        }
        return deleteDoc(doc(results_collection, resultDocs.docs[0].id));
    };
}), shareReplay(1));
export const grid_results = combineLatest([results, cards]).pipe(debounceTime(500), map(([results, cards]) => {
    const dates = uniq(results.map(result => { var _a; return (_a = result.date.toISO()) === null || _a === void 0 ? void 0 : _a.slice(0, 10).toString(); })).sort();
    const resultsWithDateIndex = results.map(result => (Object.assign(Object.assign({}, result), { date_index: dates.findIndex(date => date === result.date.toISO().slice(0, 10)) })));
    const cardResults = cards.map(card => {
        return Object.assign(Object.assign({}, card), { results: resultsWithDateIndex.filter(result => result.card === card.id) });
    });
    // Sum all the totals of the same date (the same date index)
    const totals = cardResults
        .flatMap(card => card.results)
        .reduce((totals, result) => {
        const i = totals.findIndex(t => t.date_index === result.date_index);
        if (i === -1) {
            return [
                ...totals,
                {
                    date_index: result.date_index,
                    green: result.green,
                    amber: result.amber,
                    red: result.red,
                },
            ];
        }
        const sum = {
            date_index: result.date_index,
            green: totals[i].green + result.green,
            amber: totals[i].amber + result.amber,
            red: totals[i].red + result.red,
        };
        return [...totals.slice(0, i), sum, ...totals.slice(i + 1)];
    }, []);
    return { cardResults, totals, dates };
}));
export const delete_results_on_date = results.pipe(withLatestFrom(results_collection), map(([results, results_collection]) => {
    return async (date) => {
        const toDelete = results.filter(result => result.date.toISODate() === date);
        const batch = writeBatch(db);
        for (const result of toDelete) {
            batch.update(doc(results_collection, result.date.toISO()), { deleted: true });
        }
        await batch.commit();
    };
}));
